import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EpdkXLogoComponent } from './x-logo.component';

@NgModule({
  imports: [CommonModule],
  declarations: [EpdkXLogoComponent],
  exports: [EpdkXLogoComponent]
})
export class EpdkXLogoModule { }